import { useTranslations } from "adapters/i18n";
import { useCallback } from "react";
import BenchmarkService from "services/BenchmarkService";

const EXCHANGE_OTT_URL = '/auth/from-system';

export function useBenchmark() {
  const { t } = useTranslations();

  const redirectToBenchmark = useCallback(async (): Promise<
    { error?: never; ott: string } | { error: string; ott?: never }
  > => {
    try {
      const ottResponse = await BenchmarkService.generateBenchmarkOtt();
      if (!ottResponse?.ott) {
        const message = t("errors:benchmark.ott-error");
        throw new Error(message);
      }

      const ott = ottResponse.ott;
      const baseUrl =
        process.env.REACT_APP_BENCHMARK_URL?.replace(/\/$/, "") ?? "";

      if (baseUrl === "") {
        throw new Error(
          "URL não configurada para o Benchmark. Por favor, contate o suporte.",
        );
      }

      const url = `${baseUrl}${EXCHANGE_OTT_URL}?ott=${ott}`;
      console.log("Redirecting to benchmark with URL:", url);
      window.open(url, "_blank", "noopener,noreferrer");
      return { ott };
    } catch (error) {
      console.error("Error generating benchmark OTT:", error);
      const errorMessage =
        error instanceof Error
          ? error.message
          : t("errors:benchmark.ott-error");
      console.error(errorMessage, error);
      return { error: errorMessage };
    }
  }, [t]);

  return { redirectToBenchmark };
}
